import React from "react";
import classnames from "classnames";
import styles from "../../styles/UserPasswordReset.module.scss";
import style from "../../styles/Signup.module.scss";
import GenericInput from "../../containers/helpers/genericInput";
import {
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function UserPasswordReset(props) {
  const {
    inputStyles,
    passwords,
    handleFieldChange,
    handlePasswordChange,
    profileContainerClass,
    togglePasswordVisiblity,
    passwordShown,
    passwordError,
  } = props;

  const passwordTextState = classnames({
    [styles.passwordText]: true,
    [style.error]: passwordError,
  });

  const SHOW_PASSWORD_ICON =
    "https://frontend-assets.buildbox.com/Icon_Show_Password.svg";
  const HIDE_PASSWORD_ICON =
    "https://frontend-assets.buildbox.com/Icon_Hide_Password.svg";

  return (
    <div className={styles.passwordResetWrapper}>
      <h1>Change Password</h1>
      <div className={profileContainerClass} style={{ padding: "20px 0 0" }}>
        <div className={inputStyles.errorMessage}>
          <span>{passwordError}</span>
          {passwordError && <FontAwesomeIcon icon={faExclamationTriangle} />}
        </div>
        <GenericInput
          type={passwordShown ? "text" : "password"}
          title={"Current Password:"}
          placeholder={"Enter Your Current Password"}
          inputName={"password"}
          inputValue={passwords.password}
          changeCallback={handleFieldChange}
          styles={inputStyles}
          errorState={passwordError}
          svg={passwordShown ? SHOW_PASSWORD_ICON : HIDE_PASSWORD_ICON}
          iconClickHandler={togglePasswordVisiblity}
          resetPassword={true}
        />
        <GenericInput
          type={passwordShown ? "text" : "password"}
          title={"New Password:"}
          placeholder={"Enter New Password"}
          inputName={"newPassword"}
          errorState={passwordError}
          inputValue={passwords.newPassword}
          changeCallback={handleFieldChange}
          styles={inputStyles}
          svg={passwordShown ? SHOW_PASSWORD_ICON : HIDE_PASSWORD_ICON}
          iconClickHandler={togglePasswordVisiblity}
          resetPassword={true}
        />
      </div>
      <div className={passwordTextState}>
        Passwords must be at least 8 characters long and contain at least one
        number.
      </div>
      <button
        onClick={handlePasswordChange}
        className={inputStyles.submitButton}
      >
        Update
      </button>
    </div>
  );
}
